import React, { ReactElement } from 'react';
import {
  SortLink, Table, Tbody, Th, Thead, Tr,
} from 'idsk-react-components';
import LegislativnyMaterialUlohaListPage
  from '../../../../../model/legislativnyMaterial/ulohy/LegislativnyMaterialUlohaListPage';
import './ulohyListTable.scss';
import UlohyListRow from './UlohyListRow';

interface Props {
  ulohyPage: LegislativnyMaterialUlohaListPage;
  reloadUlohyPage: () => void;
}

const UlohyListTable = ({
  ulohyPage,
  reloadUlohyPage,
}: Props): ReactElement => (
  <div className="container-ulohy">
    <div className="ulohy-list__table">
      <Table>
        <Thead>
          <Tr>
            <Th width="10%" className="th-10">
              <SortLink
                propertyName="cisloLp"
                defaultDirection="asc"
                linkColor="black"
                doubleArrows
              >
                Číslo LP
              </SortLink>
            </Th>
            <Th width="40%" className="th-40">
              <SortLink
                propertyName="nazov"
                defaultDirection="asc"
                linkColor="black"
                doubleArrows
              >Názov
              </SortLink>
            </Th>
            <Th width="10%" className="th-10">
              <SortLink
                propertyName="datumPrijatia"
                defaultDirection="asc"
                linkColor="black"
                doubleArrows
              >Dátum prijatia
              </SortLink>
            </Th>
            <Th width="10%" className="th-10">
              <SortLink
                propertyName="datumVybavenia"
                directionOfDefaultSort="asc"
                defaultDirection="asc"
                linkColor="black"
                doubleArrows
              >Dátum pre vybavenie
              </SortLink>
            </Th>
            <Th width="15%" className="th-15">
              <SortLink
                propertyName="stadium"
                defaultDirection="asc"
                linkColor="black"
                doubleArrows
              >Štádium
              </SortLink>
            </Th>
            <Th width="15%" className="last-col" />
          </Tr>
        </Thead>
        <Tbody>
          {ulohyPage.materialList.map((material) => (
            <UlohyListRow
              key={material.uuid}
              material={material}
              reloadUlohyPage={reloadUlohyPage}
            />
          ))}
        </Tbody>
      </Table>
    </div>
  </div>
);

export default UlohyListTable;
